import { z } from "zod";
import { parseRawNumber } from "../utils/hitung-data-internet";

export const DataInternetSchema = z.object({
  bitrate: z.preprocess(
    (val) => (val === "" ? undefined : String(val)),
    z
      .string({
        required_error: "Bitrate harus diisi",
        invalid_type_error: "Harus berupa angka",
      })
      .min(0, "Minimal skor adalah 0")
      .transform((val) => Number(parseRawNumber(val))),
  ),
  timestamp: z.string().min(1, "Waktu harus diisi"),
  hari: z
    .preprocess(
      (val) => (val === "" ? undefined : Number(val)),
      z
        .number({
          invalid_type_error: "Harus berupa angka",
        })
        .int("Harus berupa bilangan bulat")
        .min(0, { message: "Minimal skor adalah 0" })
        .optional(),
    )
    .refine((val) => val !== undefined, {
      message: "Hari harus diisi",
    }),
});

export type DataInternetInput = z.infer<typeof DataInternetSchema>;
